export default __webpack_public_path__ + "static/media/night-forest.57002b4e.ogg";